/* Auto generated file */
/* eslint-disable */
import { SVGSprite, type SVGSpriteProps } from '../svg/SVGBase';

const Skiff = ({ color = 'primary', aspectRatio = '559/137', ...rest}: SVGSpriteProps) =>
    <SVGSprite use="Skiff" aspectRatio={aspectRatio} color={color} {...rest} />;

export { Skiff, Skiff as default };
